module.exports = __webpack_public_path__ + "static/prepare-5b859e3127986d15024a790dcd9e5c33.png";